<div *ngIf="store.players.length > 0">

    <div style="overflow-x: auto;">
        <div class="d-flex">
            <div style="width:16em;min-width:16em" *ngFor="let p of store.players" class="player_box card m-2"
                [ngClass]="{'selected': p === player}">

                <app-player-block [player]="p" (click)="PlayerLoaded( p, true)"></app-player-block>
            </div>
        </div>

    </div>


    <div>


        <div style="background-color: lightgray; margin-top:10px; margin-bottom: 10px;" class="d-flex"
            *ngIf="player?.equipment">

            <div class="card m-2" style="width: 10em; min-width: 10em;" *ngIf="player">
                <div class="card-body" (click)="PlayerLoaded( player, true)">
                    <h6>Equipment Total</h6>
                    <div>
                        <app-attribute-store [attributes]="player.equipment_attributes"></app-attribute-store>
                    </div>
                </div>

            </div>

            <div style="overflow-x: auto;" class="d-flex">
                <div class="card m-2" style="width: 9rem;min-width:9rem;min-height: 133px;"
                    (click)="SetFilter(item.slot)" *ngFor="let item of equipment">
                    <div class="card-body" *ngIf="item.item as item">
                        <h5 class="card-title">{{item.name}} <span *ngIf="item.tier > 1"
                                class="badge text-bg-secondary">{{item.tier}}</span>
                        </h5>
                        <div>
                            <app-attribute-store [attributes]="item.diff"
                                [multiplier]="store.TierMultiplier(item.tier)"></app-attribute-store>
                        </div>
                    </div>
                    <div class="card-body" *ngIf="!item.item">

                    </div>

                </div>
            </div>



        </div>


        <div class="d-flex ">
            <span>gold: </span>
            <span>{{store.gold}}</span>
            <button (click)="Sort()">Sort</button>
            <button (click)="MergeAll()">MERGE ALL</button>
        </div>
        <div class="d-flex flex-wrap">
            <div *ngFor="let item of enhancedinventory" class="card m-2" style="width: 9em; min-height: 133px;">
                <ng-container *ngIf="item.name">
                    <div class="card-body">
                        <h5 class="card-title">{{item.name}} <span *ngIf="item.tier > 1"
                                class="badge text-bg-secondary">{{item.tier}}</span>
                            ({{item.quantity}})</h5>


                        <div class="d-flex-off">
                            <button class="flex-fill btn btn-sm btn-primary " (click)="Equip( item)"
                                *ngIf="player && inventory[item.name].equip_slot">EQUIP</button>
                            <button class="btn btn-primary" (click)="Use(item)"
                                *ngIf="player && inventory[item.name].consumable">USE</button>

                            <button class="flex-fill btn btn-sm"
                                [ngClass]="{'btn-success': item.quantity >= 2, 'btn-outline-secondary': item.quantity < item.tier+1}"
                                (click)="Merge( item)" [disabled]="item.quantity < item.tier+1 ">MERGE
                                {{item.tier+1}}</button>

                            <button class="flex-fill btn btn-sm btn-secondary" (click)="Sell(item)">SELL - {{
                                GetPrice(item) |
                                number
                                }}</button>

                        </div>
                        <div *ngIf="item.diff" class="">
                            <app-attribute-store [attributes]="item.diff" [diff]="true"></app-attribute-store>
                        </div>


                    </div>
                </ng-container>



            </div>
        </div>
    </div>

</div>